import type { Consent } from '@sky-distribution/digital-gp-submission';

export const mapConsentsByStatus = (
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
): Consent[] => {
  const consentDictionaryByName = new Map(
    consentDictionary.map((consent) => [consent.name, consent]),
  );

  return Object.entries(consentStatus).map(([name, isAccepted]) => {
    const consent = consentDictionaryByName.get(name);
    const id = consent?.id != null ? String(consent.id) : undefined;
    const status = isAccepted ? 'Accepted' : 'Rejected';

    return {
      ...consent,
      status,
      name,
      ...(id !== undefined && {
        id,
      })
    };
  });
};
